import { ProductProcessDefinitionDetailDto } from '@/api/backoffice/clients';
import { ENUM_StatusTypes } from './configuration-enumerations.common';

export const getProductProcessDefinitionLabel = (definition: ProductProcessDefinitionDetailDto) => {
    // toon status label indien de status verschillend van Actief
    let label = definition.label;
    if (definition.statusId != ENUM_StatusTypes.Actief.id) {
        const statusLabel = Object.values(ENUM_StatusTypes).find((x) => x.id == definition.statusId)?.name;
        label = `${definition.label} - ${statusLabel}`;
    }
    return label;
};

export enum ProductProcessDefinitionActionButtonType {
    ChangeStatus = 'ChangeStatus',
    Duplicate = 'Duplicate',
    CascadeDelete = 'CascadeDelete',
    Export = 'Export',
    DryRun = 'DryRun',
    Dependencies = 'Dependencies',
    GenerateReport = 'GenerateReport'
}
